import React from 'react';

interface ToggleFieldProps {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  description?: string;
}

const ToggleField: React.FC<ToggleFieldProps> = ({ label, value, onChange, description }) => (
  <button
    type="button"
    onClick={() => onChange(!value)}
    className="flex w-full items-center justify-between rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-left transition hover:bg-white/10"
  >
    <div>
      <div className="text-sm font-semibold text-white">{label}</div>
      {description && <div className="mt-1 text-sm text-white/45">{description}</div>}
    </div>
    <div
      className={`relative h-7 w-14 rounded-full border transition ${
        value ? 'border-amber-300/40 bg-amber-400/35' : 'border-white/10 bg-white/10'
      }`}
    >
      <span
        className={`absolute top-1 h-5 w-5 rounded-full bg-white transition ${
          value ? 'left-8' : 'left-1'
        }`}
      />
    </div>
  </button>
);

export default ToggleField;

